import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
// import { Link } from "react-router-dom";

// import Images
import team0 from "../../assets/images/team/team-0.jpg";
import team1 from "../../assets/images/team/team-1.jpg";
import team2 from "../../assets/images/team/team-2.jpg";
// import team3 from "../../assets/images/team/team-3.jpg";
import team4 from "../../assets/images/team/team-4.jpg";
import team5 from "../../assets/images/team/team-5.jpg";
import team6 from "../../assets/images/team/team-6.jpg";
import team7 from "../../assets/images/team/team-7.jpg";
import team8 from "../../assets/images/team/team-8.jpg";
// import team9 from "../../assets/images/team/team-9.jpg";
import team10 from "../../assets/images/team/team-10.jpg";
import team11 from "../../assets/images/team/team-11.jpg";
import team12 from "../../assets/images/team/team-12.jpg";
import team13 from "../../assets/images/team/team-13.jpg";
import team14 from "../../assets/images/team/team-14.jpg";
import team15 from "../../assets/images/team/team-15.jpg";
import team16 from "../../assets/images/team/team-16.jpg";
// import appStore from "../../assets/images/img-appstore.png";
// import googleplay from "../../assets/images/img-googleplay.png";
import ModalSabar from "../../components/team-detail/modalSabar";
import ModalIcon from "../../components/team-detail/modalIcon";
import ModalTirta from "../../components/team-detail/modalTirta";
// import ModalMaliha from "../../components/team-detail/modalMaliha";
// import ModalRuth from "../../components/team-detail/modalRuth";
import useLang from "hooks/useLang";

const OurTeam = () => {
  const [isHovered, setHover] = useState({ display: "none" });
  const [modalSabar, setModalSabar] = useState(false);
  const [modalIcon, setModalIcon] = useState(false);
  const [modalTirta, setModalTirta] = useState(false);
  // const [modalMaliha, setModalMaliha] = useState(false);
  // const [modalRuth, setModalRuth] = useState(false);
  const { lang } = useLang();

  return (
    <React.Fragment>
      {/* <section id="team">
        
      </section> */}
      <section className="section team" id="team-adinata">
        <Container>
          <Row className="justify-content-center">
            <Col lg={12} style={{textAlign: "-webkit-center"}}>
              {/* <div className="sec-hd">
                <span className="heading"></span> */}
                <h1 className="sec-title">{lang.others.our_team}</h1>
                {/* <span className="heading"></span>
              </div> */}
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg={3} md={6}>
              <div className="team-box">
                <Row className="justify-content-end"></Row>
              </div>
            </Col>

            <Col lg={12}>
              <div className="tab-container effectTab-header" id="style_10">
                <div className="wrapper">
                  <Row>
                    <div className="tab">
                      <div className="container" data-aos="fade-up">
                        <div className="row">
                          <Col lg={12}>
                            <div className="member box-tab">
                              <div
                                id="sabar-sitorus"
                                className="pic owner owner-new effect"
                                onMouseOver={() => setHover(true)}
                                onMouseLeave={() => setHover(false)}
                              >
                                <img src={team0} alt="" />
                                {isHovered && (
                                  <div className="detail">
                                    <Button
                                      size="sm"
                                      variant="primary"
                                      onClick={() => setModalSabar(true)}
                                    >
                                      Detail
                                    </Button>
                                  </div>
                                )}
                              </div>
                              <ModalSabar
                                show={modalSabar}
                                onHide={() => setModalSabar(false)}
                              />
                              <h4>Sabar Sitorus</h4>
                              <span>Chief Visionary Officer (CVO)</span>
                            </div>
                          </Col>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 tab">
                      <Row>
                        <div className="container" data-aos="fade-up">
                          <div className="row">
                            <Col lg={6} sm={6}>
                              <div className="member box-tab">
                                <div
                                  className="pic owner owner-new effect"
                                  onMouseOver={() => setHover(true)}
                                  onMouseLeave={() => setHover(false)}
                                >
                                  {/* <img src={team1} alt="" className="team1"/> */}
                                  <img src={team1} alt=""/>
                                  {isHovered && (
                                    <div className="detail">
                                      <Button
                                        size="sm"
                                        variant="primary"
                                        onClick={() => setModalIcon(true)}
                                      >
                                        Detail
                                      </Button>
                                    </div>
                                  )}
                                </div>
                                <ModalIcon
                                  show={modalIcon}
                                  onHide={() => setModalIcon(false)}
                                />
                                <h4>Icon</h4>
                                <span>Group CEO & Co-Founder</span>
                              </div>
                            </Col>
                            <Col lg={6} sm={6}>
                              <div className="member box-tab">
                                <div
                                  className="pic owner owner-new effect"
                                  onMouseOver={() => setHover(true)}
                                  onMouseLeave={() => setHover(false)}
                                >
                                  <img src={team2} alt=""/>
                                  {isHovered && (
                                    <div className="detail">
                                      <Button
                                        size="sm"
                                        variant="primary"
                                        onClick={() => setModalTirta(true)}
                                      >
                                        Detail
                                      </Button>
                                    </div>
                                  )}
                                </div>
                                <ModalTirta
                                  show={modalTirta}
                                  onHide={() => setModalTirta(false)}
                                />
                                <h4>Tirta</h4>
                                <span>Managing Partner & CFO</span>
                              </div>
                            </Col>
                            {/* <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div
                                  className="pic owner owner-new effect"
                                  onMouseOver={() => setHover(true)}
                                  onMouseLeave={() => setHover(false)}
                                >
                                  <img src={team3} alt=""/>
                                  {isHovered && (
                                    <div className="detail">
                                      <Button
                                        size="sm"
                                        variant="primary"
                                        onClick={() => setModalMaliha(true)}
                                      >
                                        Detail
                                      </Button>
                                    </div>
                                  )}
                                </div>
                                <ModalMaliha
                                  show={modalMaliha}
                                  onHide={() => setModalMaliha(false)}
                                />
                                <h4>Maliha</h4>
                                <span>Senior Manager Tax</span>
                              </div>
                            </Col> */}
                            {/* <Col lg={4} sm={6}>
                              <div className="member box-tab">
                                <div
                                  className="pic owner owner-new effect"
                                  onMouseOver={() => setHover(true)}
                                  onMouseLeave={() => setHover(false)}
                                >
                                  <img src={team4} alt=""/>
                                  {isHovered && (
                                    <div className="detail">
                                      <Button
                                        size="sm"
                                        variant="primary"
                                        onClick={() => setModalRuth(true)}
                                      >
                                        Detail
                                      </Button>
                                    </div>
                                  )}
                                </div>
                                <ModalRuth
                                  show={modalRuth}
                                  onHide={() => setModalRuth(false)}
                                />
                                <h4>Ruth</h4>
                                <span>Tax Manager</span>
                              </div>
                            </Col> */}

                            <Row
                              className="justify-content-center"
                              style={{ marginTop: "40px" }}
                            >
                              <Col lg={12}>
                                <div
                                  className="sec-hd"
                                  style={{ marginBottom: "20px" }}
                                >
                                  <span className="heading"></span>
                                  <span className="heading"></span>
                                </div>
                              </Col>
                            </Row>

              {/* ========================= EMPLOYEE ========================= */}
                            {/* <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team5} className="height-266 custom-pic-mobile-height" alt=""/>
                                </div>
                                <h4>Farra</h4>
                                <span>Tax Specialist</span>
                              </div>
                            </Col>
                            <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team6} className="height-266 custom-pic-mobile-height" alt=""/>
                                </div>
                                <h4>Iswan</h4>
                                <span>Tax Specialist</span>
                              </div>
                            </Col> */}
                            <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team7} alt=""/>
                                </div>
                                <h4>Ferdinand</h4>
                                <span>Tax Specialist</span>
                              </div>
                            </Col>
                            <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team8} alt=""/>
                                </div>
                                <h4>Handoko</h4>
                                <span>Manager Finance</span>
                              </div>
                            </Col>
                            {/* <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team9} alt=""/>
                                </div>
                                <h4>Santi</h4>
                                <span>Senior Human Capital</span>
                              </div>
                            </Col> */}
                            {/* <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team10} alt=""/>
                                </div>
                                <h4>Alyssa</h4>
                                <span>Legal Corporate</span>
                              </div>
                            </Col> */}
                            <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team11} alt=""/>
                                </div>
                                <h4>Boy</h4>
                                <span>Senior Finance</span>
                              </div>
                            </Col>
                            <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team15} className="height-266 custom-pic-mobile-height" alt=""/>
                                </div>
                                <h4>Aulia</h4>
                                <span>Senior People</span>
                              </div>
                            </Col>
                            <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team12} alt=""/>
                                </div>
                                <h4>Kiki</h4>
                                <span>Internal Operations</span>
                              </div>
                            </Col>
                            {/* <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team13} alt=""/>
                                </div>
                                <h4>Rara</h4>
                                <span>Social Media Admin</span>
                              </div>
                            </Col> */}
                            <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team16} className="height-266 custom-pic-mobile-height" alt=""/>
                                </div>
                                <h4>Putri</h4>
                                <span>Social Media Admin</span>
                              </div>
                            </Col>
                            <Col lg={3} sm={6}>
                              <div className="member box-tab">
                                <div className="pic employee effect">
                                  <img src={team14} alt=""/>
                                </div>
                                <h4>Edy</h4>
                                <span>Driver</span>
                              </div>
                            </Col>
                          </div>
                        </div>
                      </Row>
                    </div>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default OurTeam;
